import { v4 as uuid } from 'uuid';
import type { IJobItem } from './JobItem.interface';
import { toUUID } from '../../util/transform';

export default class JobItem implements IJobItem {
  id: string;
  name: string;
  isActive: boolean;

  getName() {
    return this.name;
  }

  static build = (data: IJobItem) => new JobItem(data);
  static blank = () => new JobItem();

  /**
   * Constructor
   * @param {IJobItem} data
   */
  constructor(data?: IJobItem) {
    this.id = toUUID(data?.id) || uuid();
    this.name = data?.name || '';
    this.isActive = data?.isActive === true;
  }
}
